import React, { Component } from 'react'
import PropTypes from 'prop-types'

import checkIcon from 'images/check.svg'
import warningIcon from 'images/warning-icon.svg'
import errorIcon from 'images/close.svg'
import infoIcon from 'images/info-icon.svg'

const alertTypes = {
  error: [errorIcon, 'alert alert-error'],
  success: [checkIcon, 'alert alert-success'],
  warning: [warningIcon, 'alert alert-warning'],
  default: [infoIcon, 'alert alert-default'],
}

//   t: PropTypes.func.isRequired, TODO impĺement translation function
// TODO implement translations
class Alert extends Component {
  static propTypes = {
    /* The text that will be displayed inside the alert */
    text: PropTypes.string.isRequired,

    /* Defines the type of the alert */
    alertType: PropTypes.oneOf(Object.keys(alertTypes)),

    /* The text that will be displayed inside the action button, if the button will be shown */
    actionName: PropTypes.string,

    /* Callback function triggered when the confirm button is clicked */
    onConfirm: PropTypes.func,

    /* Callback function triggered when the alert is closed */
    onClose: PropTypes.func,
  }

  state = {
    /* Stores the information of wheter the alert is or not shown */
    isShown: true,
  }

  dismissAlert(callBack) {
    this.setState({ isShown: false }, callBack)
  }

  render() {
    const {
      text,
      alertType,
      actionName = null,
      onConfirm = () => {},
      onClose = () => {},
    } = this.props

    const { isShown } = this.state

    const [icon, className] = alertTypes[alertType]

    return (
      <>
        {isShown && (
          <div className={className}>
            <div>
              <img src={icon} />
            </div>
            <div>
              <span>{text}</span>
            </div>
            <div>
              {actionName && <button onClick={onConfirm}>{actionName}</button>}
              <button onClick={() => this.dismissAlert(onClose)}>Close</button>
            </div>
          </div>
        )}
      </>
    )
  }
}

export default Alert
